var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Box, withStyles } from '@material-ui/core';
import React from 'react';
import { useBattleFeedbackContext } from './battle-feedback-context';
import { FeedbackEffectsStack } from './feedback-effects/feedback-effects-stack';
import { FeedbackTurn } from './feedback-turn';
var Separator = withStyles(function (_a) {
    var palette = _a.palette;
    return ({
        root: {
            width: '100%',
            height: 2,
            backgroundColor: palette.background.paper
        }
    });
})(function (_a) {
    var classes = _a.classes;
    return React.createElement("div", { className: classes.root });
});
var isEmptyArray = function (value) { return Array.isArray(value) && value.length === 0; };
export var BattleFeedback = function (_a) {
    var previewEffects = _a.previewEffects, futureEffects = _a.futureEffects, currentEffects = _a.currentEffects, turnInfos = _a.turnInfos;
    var previewEnabled = useBattleFeedbackContext().previewEnabled;
    var renderPreviewEffects = function () {
        if (!previewEffects) {
            return null;
        }
        return (React.createElement(FeedbackEffectsStack, __assign({}, previewEffects, { opacity: 'animate' })));
    };
    var renderFutureEffects = function () {
        return (futureEffects !== null && futureEffects !== void 0 ? futureEffects : []).map(function (props, i) { return (React.createElement(FeedbackEffectsStack, __assign({ key: i }, props, { condensed: true, opacity: 'low' }))); });
    };
    var renderCurrentEffects = function () {
        if (!currentEffects) {
            return null;
        }
        return (React.createElement(FeedbackEffectsStack, __assign({}, currentEffects, { condensed: previewEnabled })));
    };
    var renderTurnInfos = function () {
        if (!turnInfos) {
            return null;
        }
        return (React.createElement(FeedbackTurn, __assign({}, turnInfos)));
    };
    var content = [
        renderPreviewEffects(),
        renderFutureEffects(),
        renderCurrentEffects(),
        renderTurnInfos()
    ]
        .filter(function (node) { return node && !isEmptyArray(node); })
        .map(function (node, i, list) {
        var isLastNode = i === list.length - 1;
        return (React.createElement(React.Fragment, { key: i },
            node,
            !isLastNode && (React.createElement(Separator, null))));
    });
    return (React.createElement(Box, { display: 'inline-flex', flexDirection: 'column' }, content));
};
